<template>
  <div class="fixed-top" style="z-index:501">
    <div v-if="Popup===true" class="popup-overlay" @click.self="closePopup">
      <div class="popup-content">
        <div class="close">
          <img style="width:100%" @click="closePopup" src="../assets/book/ai_help_img01.png">
        </div>
          <div class="title">
            <h3 class="my-auto ml-3">Operating Instructions</h3>
          </div>
          <div class="content">
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">1</div>
                <div class="text ml-2">Click <span><img src="../assets/book/ai_help01_icon_01.png" style="max-width:3rem" alt="" srcset=""> </span> to start making your own storybook.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_01.png" alt="" srcset="">
            </div>
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">2</div>
                <div class="text ml-2">Follow the questions to choose the stage, topic, place, main character, and details of the book. The story will be generated automatically.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_02.png" alt="" srcset="">
            </div>
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">3</div>
                <div class="text ml-2">You can click to <span><img src="../assets/book/ai_help01_icon_02.png" style="max-width:3rem" alt="" srcset=""> </span> change it into different paragraphs.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_03.png" alt="" srcset="">
            </div>
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">4</div>
                <div class="text ml-2">Choose the image for your cover and contents.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_04.png" alt="" srcset="">
            </div>
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">5</div>
                <div class="text ml-2">Click <span><img src="../assets/book/ai_help01_icon_03.png" style="max-width:3rem" alt="" srcset="">  </span>to do the voice-over.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_05.png" alt="" srcset="">
            </div>
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">6</div>
                <div class="text ml-2">Click <span><img src="../assets/book/ai_help01_icon_04.png" style="max-width:3rem" alt="" srcset=""> </span> to start your voice recording.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_06.png" alt="" srcset="">
            </div>
            <div class="mb-4">
              <div class="d-flex ">
                <div class="hNum">7</div>
                <div class="text ml-2">You can read your story online anytime, or you can click <span> <img src="../assets/book/download.png" style="max-width:5rem" alt="" srcset=""> </span> to download it to your computer.</div>
              </div>
              <img class="help-img" src="../assets/help/ai_help01_img_07.png" alt="" srcset="">
            </div>
            <a href="/Live AI Story Maker User Manual.pdf" target="_blank" rel="noopener noreferrer">Download the user manual to see detailed instructions.</a>
        </div>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light d-flex ">
      <div class="container-fluid">
        <div class="col-md-6">
          <h3 class="title_words rwd-title">AI Story Maker</h3>
        </div>
        <div class="col-md-6 personal-tool d-flex justify-content-end">
          <div @click="goPage('AI_Book')" class="changeBtn pointer">
            <img src="../assets/course/but_control_icon15.png">
          </div>
          <div v-if="role!=='user'" @click="goPage('Teacher')" class="changeBtn pointer">
            <img src="../assets/course/but_page_icon20.png">
          </div>
          <div @click="goProfilePage('Book_Index')" class="changeBtn pointer">
            <img src="../assets/course/but_page_icon25.png">
          </div>
          <div @click="showPopup" class="changeBtn pointer">
            <img src="../assets/course/but_page_icon24.png">
          </div>
          <!-- <div class="changeBtn pointer">
            <img src="../assets/course/but_page_icon24.png">
          </div> -->
          <div @click="logout" class="backBtn pointer">
            <img src="../assets/course/but_list_logOut.png">
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
// import personalApi from '../store/personalApi'
import { mapGetters, mapMutations } from 'vuex'
// import api from '@/store/api'
export default {
  name: 'Navbar',
  data () {
    return {
      Popup: false,
      search: '',
      audioData: null,
      active: false,
      infoActive: false,
      toggle: false,
      auth: {
        email: '',
        password: ''
      }
    }
  },
  components: {
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val) {
          this.$emit('emitSearch', this.search)
        }
      },
      deep: true
    }
  },
  mounted () {
    // if (this.$store.state.auth.authorized) {
    //   this.getUser()
    // }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'role'
    ]),
    routeName () {
      return this.$route.name
    },
    topic () {
      return this.$route.params.topic
    },
    infoId () {
      return this.$route.params.infoId
    }
  },
  methods: {
    ...mapMutations({
      dologout: 'logout'
    }),
    logout () {
      this.$router.push({ name: 'Home' })
      this.dologout()
    },
    showPopup () {
      document.body.style.overflow = 'hidden'
      this.Popup = true
    },
    closePopup () {
      document.body.style.overflow = ''
      this.Popup = false
    },
    goBack () {
      this.$router.go(-1)
    },
    goPage (el) {
      this.$router.push({ name: el })
    },
    goProfilePage () {
      this.$router.push({ name: 'Book_Index', params: { studentId: this.userInfo.student_id } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/custom.scss";
  .navbar {
    height: 100px;
    top: 0px;
    left: 0px;
    width: 100%;
    background-image: url('../assets/topMenu_BgImg.png');
    background-repeat: repeat-x;
    background-size: 55px 100px;
    z-index: 9999999;
    border-bottom: 10px solid #fff;
    .title_words {
      text-align: left;
      text-shadow: 0px 2px rgba(181, 75, 11, 0.5);
      font-weight: 400;
      font-size: 2rem;
      color: #fff;
    }
    .personal-tool  {
      float: right;
      width: 100%;
      img {
        max-width: 80px;
      }
    }
  }
  .changeBtn {
    max-width: 80px;
    background-size: 80px 80px;
    background-image: url('../assets/course/but_pageBg.png');
  }
  .changeBtn:hover {
    background-image: url('../assets/course/but_pageBg_over.png');
  }
  .backBtn {
    max-width: 80px;
    background-size: 80px 80px;
    background-image: url('../assets/course/but_listBg.png');
  }
  .backBtn:hover {
    background-size: 80px 80px;
    background-image: url('../assets/course/but_listBg_over.png');
  }
  .popup-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10000001;
    overflow: auto;
  }
  .popup-content {
    position: relative;
    width: 92%;
    max-width: 700px;
    background-color: #FFF;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 100px;
    border-radius: 20px;
    padding-top: 45px;
    padding-bottom: 45px;
    .close {
      opacity: 1 !important;
      position: absolute;
      width: 45px;
      height: 45px;
      top: -15px;
      right: -15px;
      background-color: #ff7800;
      border-radius: 400px;
      border: 4px solid #fff;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
    .close:hover {
      filter: brightness(150%);
    }
    .title {
      position: relative;
      width: 100%;
      height: 46px;
      background-color: #f96e00;
      border-bottom: 5px solid #ffc6a4;
      margin-bottom: 30px;
      text-align: left;
      padding: 2px;
      h3 {
        color: #fff;
        margin: 5px;
      }
    }
    .content {
      padding: 25px;
      text-align: left;
      .hNum {
        width: 2.5rem !important;
        height: 2.5rem;
        text-align: center;
        line-height: 2.5rem;
        font-size: 16px;
        color: #FFF;
        background-color: #f96e00;
        border-radius: 400px;
      }
      .help-img {
        padding: 0 30px;
        border-radius: 15px;
        display: block;
        width: 100%;
        height: auto;
      }
      .text {
        padding: 0;
        margin-bottom: 20px;
        font-size: 1.25rem;
        width: 90%;
      }
    }
  }
  @media screen and (max-width: 750px) {
    .navbar {
      .title_words {
        display: none;
      }
    }
  } /*小於700*/
</style>
